<div class="section">
  <h3>{{ 'account.wishlists.widget.heading' | translate }}</h3>
  <div class="loading-container mt-auto">
    <ng-container *ngIf="(wishlistLoading$ | async) !== true; else loading">
      <ng-container *ngIf="allWishlistsItemsSkus$ | async as wishlistsItemsSkus">
        <ng-container *ngIf="wishlistsItemsSkus.length > 0; else noItems" class="section">
          <div class="product-list" data-testing-id="wishlistProductsList">
            <ish-products-list
              [productSKUs]="wishlistsItemsSkus"
              listStyle="carousel"
              listItemStyle="tile"
              [listItemConfiguration]="tileConfiguration"
            ></ish-products-list>
          </div>
        </ng-container>
        <ng-template #noItems>
          <p>{{ 'account.wishlists.no_items' | translate }}</p>
        </ng-template>
      </ng-container>
      <a routerLink="/account/wishlists" data-testing-id="emptyWishlistProductsList">{{
        'account.overview.wishlist.view_all' | translate
      }}</a>
    </ng-container>
  </div>
</div>

<ng-template #loading>
  <ish-loading></ish-loading>
</ng-template>
